import { css } from '@emotion/react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/person.pb';
import { Icon } from '@frontend/icons';
import { Photos } from '@frontend/photos';
import { useContactPanelShallowStore } from '@frontend/shared';
import { useSlidePanelShallowStore } from '@frontend/slide-panel';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Contact = Required<Pick<Person, 'firstName' | 'lastName' | 'personId'>> & {
  profileName: string;
  number: string;
  defaultName: string;
};

type ContactActionsProps = {
  contact: Contact;
  locationId: string;
  isClickable?: boolean;
  callDirection?: string;
  showOnlyName?: boolean;
};
export const ContactUserName = ({
  callDirection,
  contact,
  locationId,
  isClickable = false,
  showOnlyName = false,
}: ContactActionsProps) => {
  const { setPersonId } = useContactPanelShallowStore('setPersonId', 'personId');
  const { setShow } = useSlidePanelShallowStore('setShow');

  const { firstName, lastName, profileName, personId, number, defaultName } = contact;
  const isOutboundCall = callDirection === 'outbound';

  return (
    <div css={styles.wrapper}>
      <Photos.ContactProfilePhoto
        css={styles.avatar(isClickable)}
        disableClick={isClickable || !personId}
        locationId={locationId}
        name={profileName || defaultName}
        personId={personId}
      />
      <div css={styles.infoStack}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {firstName || lastName ? (
            <div
              css={styles.name(isClickable)}
              onClick={() => {
                if (!!personId && isClickable) {
                  setPersonId(personId, undefined, locationId);
                  setShow(true, 'contact');
                }
              }}
            >
              {!!firstName && (
                <Text as='span' weight='bold'>
                  {firstName}
                </Text>
              )}
              {!!lastName && <Text as='span'> {lastName}</Text>}
            </div>
          ) : (
            <Text as='span' color='light'>
              {number}
            </Text>
          )}
          {isOutboundCall && <Icon name='phone-outgoing-small' css={{ marginLeft: theme.spacing(1) }} />}
        </div>

        {(firstName || lastName) && !showOnlyName && (
          <Text size='small' color='light'>
            {number}
          </Text>
        )}
      </div>
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  avatar: (isClickable: boolean) =>
    css({
      cursor: isClickable ? 'pointer' : 'default',
      flexShrink: 0,
    }),
  infoStack: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }),
  name: (isClickable: boolean) =>
    css({
      cursor: isClickable ? 'pointer' : 'default',
      width: 'fit-content',
    }),
};
